export default __webpack_public_path__ + "static/media/bronze-medal.6cb4162c.png";